import { parseChecklist, resetChecklistForTemplate } from "./taskChecklist";

export function templateToForm(template) {
    if (!template) return null;
    const checklist = resetChecklistForTemplate(template.checklist);
    return {
        title: template.title || template.name || "",
        notes: template.notes || "",
        priority: template.priority || "medium",
        checklist,
        reminderPreset: template.reminder_type || "none",
        reminderCustomMinutes: Number(template.reminder_minutes) || 15,
        repetition: template.repetition || "none",
        listId: template.list_id || null,
    };
}

export function taskToTemplatePayload(task, name) {
    return {
        name: String(name || task?.title || "Untitled template").trim(),
        title: task?.title || "",
        notes: task?.notes || "",
        priority: task?.priority || "medium",
        checklist: resetChecklistForTemplate(task?.checklist),
        list_id: task?.list_id || null,
        reminder_type: task?.reminder_type || "none",
        reminder_minutes: Number(task?.reminder_minutes) || 0,
        repetition: task?.repetition || "none",
    };
}

export function templateStepCount(template) {
    return parseChecklist(template?.checklist).length;
}
